import { Alert, Anchor, Box, Title, useComputedColorScheme } from '@mantine/core'
import { useTranslation } from 'react-i18next'

import { googleMapsEmbedSrc, googleMapsLink } from '@/utils/googleMapsLink'

import { EventLocation } from './eventLocation'

type Props = {
  location?: EventLocation
  height?: number | string
}

const DARK_IFRAME_FILTER = 'invert(90%) hue-rotate(180deg) brightness(0.95) contrast(0.9)'

const GoogleMapsPanel = ({ location, height = 360 }: Props) => {
  const { t } = useTranslation('unexpectedEvents')
  const isDark = useComputedColorScheme('light') === 'dark'
  const apiKey =
    import.meta.env.VITE_GOOGLE_MAPS_API_KEY ||
    (typeof window !== 'undefined' ? window.ENV?.GOOGLE_MAPS_API_KEY : undefined)

  if (!location) {
    return (
      <>
        <Title order={5} mb="xs">
          {t('panels.googleMaps')}
        </Title>
        <Alert color="gray" variant="light">
          {t('header.noGps')}
        </Alert>
      </>
    )
  }

  return (
    <>
      <Title order={5} mb="xs">
        <Anchor
          href={googleMapsLink(location.latitude, location.longitude)}
          target="_blank"
          rel="noopener noreferrer"
          underline="hover"
        >
          {t('panels.googleMaps')}
        </Anchor>
      </Title>
      <Box style={{ height, width: '100%' }}>
        {apiKey ? (
          <iframe
            title="google-maps"
            src={googleMapsEmbedSrc(location.latitude, location.longitude, apiKey)}
            style={{ border: 'none', width: '100%', height: '100%', filter: isDark ? DARK_IFRAME_FILTER : undefined }}
            referrerPolicy="no-referrer-when-downgrade"
            allowFullScreen
          />
        ) : (
          <Alert color="gray" variant="light">
            {t('header.openInGoogleMaps')}
          </Alert>
        )}
      </Box>
    </>
  )
}

export default GoogleMapsPanel
